import { UserGroup } from 'types/accessControll.types';
import { ShowIfUserIsInUserGroup } from '../../ShowIfUserIsInUserGroup';
import DefaultEvaluationOpen from './DefaultEvaluationOpen';
import UpsertIntentsContainer from './UpsertIntents';
import QuestionConversationSettings from '../../CreateQuestion/QuestionConversationSettings';
import ObjectivesContainer from './Objectives';
import SlotFillingContainer from './SlotFilling';

const CreateOpen = () => {
  return (
    <div className="flex flex-col justify-between gap-10">
      <UpsertIntentsContainer />
      <ShowIfUserIsInUserGroup group={UserGroup.HUBERT}>
        <SlotFillingContainer />
        <ObjectivesContainer />
        <DefaultEvaluationOpen />
        <QuestionConversationSettings />
      </ShowIfUserIsInUserGroup>
    </div>
  );
};

export default CreateOpen;
